import Backdrop from 'components/Common/Backdrop/Backdrop';
import StudioSelectionSearchBar from 'components/Common/StudioSelectionSearchBar/StudioSelectionSearchBar';
import Layout from 'components/Layout/Layout';
import ProductSelectPopup from 'components/StudioSearchPage/StudioSearchResults/ProductSelectPopup/ProductSelectPopup';
import StudioSelectionSearchResults from 'components/StudioSearchPage/StudioSearchResults/StudioSelectionSearchResults';
import useActiveRouteParameter from 'hooks/useActiveRouteParameter';
import useCategoryURLParams from 'hooks/useCategoryURLParams';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import fetchStudioSearchCategoryDataOperation from 'store/studioSearch/operation/fetchStudioSearchCategoryDataOperation';
import setParamsFromQueryStringOperation from 'store/studioSearch/operation/setParamsFromQueryStringOperation';
import setParamsFromQueryStringServerOperation from 'store/studioSearch/operation/setParamsFromQueryStringServerOperation';
import getStudioSearchCategory from 'store/studioSearch/selector/getStudioSearchCategory';
import getStudioSearchQuery from 'store/studioSearch/selector/getStudioSearchQuery';
import { setStudioSearchCategoryFiltersAction } from 'store/studioSearch/slice';
import SSRParams from 'utils/class/SSRParams';
import gtmSendFunnelStepEvent, { FUNNEL_STEPS } from 'utils/gtm/gtmSendFunnelStepEvent';
import OpHellobar from 'components/Common/op-ui-wrappers/OpHellobar/OpHellobar';
import styles from './StudioSearchPage.module.scss';

const StudioSearchPage = () => {
  const dispatch = useDispatch();
  const urlParams = useCategoryURLParams(1);
  const location = useLocation();
  const query = useSelector(getStudioSearchQuery);
  const category = useSelector(getStudioSearchCategory);
  const trackLocationChange = useRef<boolean>(false);
  const categoryId = useActiveRouteParameter('categoryId');
  const filter = useActiveRouteParameter('filter', '[]') as string;
  useEffect(() => {
    gtmSendFunnelStepEvent(FUNNEL_STEPS.searchResults);
    dispatch(setParamsFromQueryStringOperation(urlParams.queryString, false));
    dispatch(setStudioSearchCategoryFiltersAction(filter));
    dispatch(fetchStudioSearchCategoryDataOperation());
    trackLocationChange.current = true;
  }, []);

  useEffect(() => {
    if (!trackLocationChange.current) return;
    const queryString = new URLSearchParams(location.search);
    dispatch(setParamsFromQueryStringOperation(queryString));
    dispatch(setStudioSearchCategoryFiltersAction(String(filter) || '[]'));
  }, [location]);

  return (
    <>
      <OpHellobar hellobarText={category?.helloBar} variant="darkgray" />
      <Layout>
        <StudioSelectionSearchBar categoryId={Number(categoryId)} className={styles.searchBar} initialQuery={query} />
        <StudioSelectionSearchResults />
        <Backdrop />
        <ProductSelectPopup />
      </Layout>
    </>
  );
};

export default StudioSearchPage;

// Executed on the server to prepare initial data
export const fetchStudioSearchPageInitialData = (params: SSRParams): Promise<any>[] => {
  const { req } = params;
  const { query } = req;
  if (query) {
    params.dispatch(setParamsFromQueryStringServerOperation(params.req.query));
  }
  return [];
};
